import {isDefined, panic, Progress, UUID} from "@opendaw/lib-std"
import {AudioData, WavFile} from "@opendaw/lib-dsp"
import {SampleMetaData} from "@opendaw/studio-adapters"
import {SampleProvider} from "@opendaw/studio-core"
import {DrumKits} from "./DrumKits"

const FileRoot = "https://assets.opendaw.studio/samples"
const RequestOptions: RequestInit = {
    method: "GET",
    headers: {"Authorization": `Basic ${btoa("openDAW:prototype")}`}
}

export const OpenSampleProvider: SampleProvider = {
    fetch: async (uuid: UUID.Bytes, progress: Progress.Handler): Promise<[AudioData, SampleMetaData]> => {
        const key = UUID.toString(uuid)
        const response = await fetch(`${FileRoot}/${key}`, RequestOptions)
        if (!response.ok) {
            return panic(`Could not fetch sample ${key}: ${response.status} ${response.statusText}`)
        }
        const audioData = WavFile.decodeFloats(await response.arrayBuffer())
        progress(1.0)
        const known = DrumKits.byUuid(key)
        return [audioData, {
            name: isDefined(known) ? known.name : key,
            bpm: 120,
            duration: audioData.numberOfFrames / audioData.sampleRate,
            sample_rate: audioData.sampleRate,
            origin: "openDAW"
        }]
    }
}
